<template>
  <section class="hero is-default is-bold">
    <div class="hero-body">
      <div class="container">
        <div class="columns">
          <div class="column is-8 is-offset-2">
            <survey-form
              v-if="activeStep === 0"
              :isSimulation="true"
              :totalStep="totalStep"
              v-model="commute"
              @submit="nextStep"
            />
            <commute-form
              v-else-if="activeStep === 1"
              :isSurvey="true"
              :startStep="2"
              :totalStep="totalStep"
              :year="year"
              :hasWorkingDay2="hasWorkingDay2"
              v-model="commute"
              :isSimulation="true"
              @updateHasWorkingDay2="updateHasWorkingDay2"
              @back="activeStep = 0"
              @submit="nextStep"
            />
            <template v-else-if="activeStep === 2">
              <survey-result
                :survey="commute"
                :isSimulation="true"
                :isSurvey="false"
                :simulations="simulations"
                :year="year"
                :commutesActive="true"
                :foodsActive="false"
              />
              <br />
              <div class="columns">
                <div class="column">
                  <button class="button is-fullwidth" @click="resetSimulations">
                    <span class="icon is-small"
                      ><i class="fa fa-refresh"></i
                    ></span>
                    <span>{{ $t('viewCommutesSimulator.reset') }}</span>
                  </button>
                </div>
                <div class="column">
                  <button
                    class="button is-fullwidth is-primary"
                    @click="newSimulation"
                  >
                    <span class="icon is-small"
                      ><i class="fa fa-plus"></i
                    ></span>
                    <span>{{
                      $t('viewCommutesSimulator.new-simulation')
                    }}</span>
                  </button>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Commute from '@/models/carbon/Commute.js'

export default {
  name: 'CommutesSimulation',
  components: {
    'survey-form': () => import('@/components/carbon/forms/survey/Form.vue'),
    'survey-result': () =>
      import('@/components/carbon/forms/survey/Result.vue'),
    'commute-form': () => import('@/components/carbon/forms/commutes/Form.vue')
  },
  data () {
    return {
      error: '',
      simulations: [],
      activeStep: 0,
      hasWorkingDay2: false,
      year: new Date().getFullYear(),
      commute: Commute.createEmpty()
    }
  },
  computed: {
    totalStep: function () {
      if (this.commute.nWorkingDay === 0) {
        return 1
      } else if (this.commute.nWorkingDay === 1) {
        return 4
      } else if (!this.hasWorkingDay2) {
        return 4
      } else {
        return 7
      }
    }
  },
  methods: {
    updateHasWorkingDay2 (value) {
      this.hasWorkingDay2 = value
    },
    nextStep () {
      if (this.activeStep === 0 && this.commute.nWorkingDay === 0) {
        this.addSimulation()
        this.activeStep = 2
      } else if (this.activeStep === 1) {
        this.addSimulation()
        this.activeStep = 2
      } else {
        this.activeStep += 1
      }
    },
    addSimulation () {
      this.commute = Commute.createFromObj(this.commute)
      this.commute.clean()
      this.simulations.push({
        commute: this.commute,
        year: this.year
      })
      window.scrollTo(0, 0)
    },
    resetSimulations () {
      this.simulations = []
      this.commute = Commute.createEmpty()
      this.activeStep = 0
      this.hasWorkingDay2 = false
      window.scrollTo(0, 0)
    },
    newSimulation () {
      this.commute = Commute.createEmpty()
      this.year = new Date().getFullYear()
      this.activeStep = 0
      this.hasWorkingDay2 = false
      window.scrollTo(0, 0)
    }
  },
  mounted () {
    this.commute = Commute.createEmpty()
    this.year = new Date().getFullYear()
    window.scrollTo(0, 0)
  }
}
</script>
